import { ClientHandler } from '../types';
import { disneyHandler } from './client-handlers/DISNEY/disney-handler';
import { resumidoHandler } from './client-handlers/RESUMIDO/resumido-handler';
import { GVAZHandler } from './client-handlers/GVAZ';
import { macroHandler } from './client-handlers/MACRO';

const CLIENT_HANDLERS: Record<string, ClientHandler> = {
  DISNEY: disneyHandler,
  RESUMIDO: resumidoHandler,
  GVAZ: GVAZHandler,
  MACRO: macroHandler,
  TEST: macroHandler // TEST usa las mismas reglas que MACRO
};

export const getClientHandler = (clientId: string): ClientHandler => {
  return CLIENT_HANDLERS[clientId] || {};
};
